import { render, staticRenderFns } from "./CalendarEventUnread.vue?vue&type=template&id=e2194112&"
import script from "./CalendarEventUnread.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventUnread.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports